import { StaticImage } from "gatsby-plugin-image"
import * as React from "react"
import SocialBar from "./social-bar"
import MenuBar from "./menu-bar"
import Logo from "../../icons/logo"
import FormatPixel from "../utils/formatPixel"



const Header = () => {

  const links = [
    {
      name: 'Home',
      link: 'https://www.jamesst.com.au/',
      color: '#d25132'
    },
    {
      name: 'fashion',
      link: 'https://www.jamesst.com.au/fashion',
      color: '#354a5a'
    },
    {
      name: 'food & drink',
      link: 'https://www.jamesst.com.au/food-drink',
      color:'#808568',
    },
    {
      name: 'Health & Beauty',
      link: 'https://www.jamesst.com.au/health-beauty',
      color: '#808568'
    },
    {
      name: 'lifestyle & design',
      link: 'https://www.jamesst.com.au/lifestyle-design',
      color: '#91a6a1'
    },
    {
      name: 'stay',
      link: 'https://www.jamesst.com.au/stay',
      color:'#e58a21'
    },
    {
      name: 'news',
      link: 'https://www.jamesst.com.au/stay',
      color: '#984a2a'
    },
    {
      name: 'events',
      link: 'https://www.jamesst.com.au/events',
      color: '#999'
    }
  ]


  return (
    <header className="flex flex-col">
      <SocialBar />
      <StaticImage alt=''  src='../../images/gradient.png' />

      <div className=" pt40 pb40 bg-black flex justify-center">
        <div className=" max-w-1200 grid grid-3 w-full md:grid-cols-1">
        <div className="flex flex-col ju-c items-center h6 md:hidden">
          <h6 className="uppercase" >
            <FormatPixel text='uplate' />
          </h6>
        </div>
        <div className="flex flex-col ju-c items-center">
          <Logo />
        </div>
        <div className="flex flex-col ju-c items-center h6 md:hidden  ">
          <h6 className="pixel uppercase">
          2022
          </h6>
        </div>
        </div>
      </div>

      <StaticImage  alt=''  src='../../images/gradient.png' />
      <MenuBar links={links} />
    </header>)
}


export default Header
